// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BoNyi","label":"styles_label__1UoKz"};